"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var BaseComponent_1 = require("./base/BaseComponent");
var ko = require("knockout");
var $ = require("jquery");
var numeral = require("numeral");
var _ = require("lodash");
var merchantUtils_1 = require("../../app/utils/merchantUtils");
var BuyButtonComponent = (function (_super) {
    __extends(BuyButtonComponent, _super);
    function BuyButtonComponent(params, element, templateNodes) {
        var _this = this;
        _super.call(this, params, element, templateNodes);
        this.priceFormat = "0,0.[00]";
        this.enabledPayMethods = [];
        this.saveCard = false;
        this.balance = 0;
        this.paySelectionMin = 0;
        this.paySelectionCommission = 0;
        this.cloudPaymentsCommission = 0;
        this.cloudPaymentsMin = 0;
        this.payAnyWayCommission = 0;
        this.payAnyWayMin = 0;
        this.robokassa2Commission = 0;
        this.unitpayCommission = 0;
        this.unitpayMin = 0;
        this.mode = ko.observable("work");
        this.stage = ko.observable("loading");
        this.errorMessages = ko.observableArray([]);
        this.customRewardTitle = "Ввести произвольное значение (10 - 15 000 ₽)";
        this.rewardOptions = [10, 25, 50, 100, 250, 500, this.customRewardTitle];
        this.rewardSelectedOption = ko.observable(25);
        this.isCustomRewardValue = ko.pureComputed(function () {
            return _this.rewardSelectedOption() === _this.customRewardTitle;
        });
        this.minReward = 10;
        this.maxReward = 15000;
        this.rewardStep = 10;
        this.savePaymentMethod = ko.observable();
        this.savePaymentMethodDontAsk = ko.observable();
        this.selectedPaymentMethod = ko.observable();
        this.customRewardValue = ko.observable(25).extend({
            required: {
                onlyIf: function () {
                    return (_this.stage() === "setRewardAmount" || _this.stage() === "setBalanceAmount") && _this.isCustomRewardValue();
                }
            },
            min: this.minReward,
            max: this.maxReward
        });
        this.rewardValue = ko.pureComputed(function () {
            var isCustom = _this.isCustomRewardValue(), selectedOption = _this.rewardSelectedOption(), customReward = _this.customRewardValue();
            return isCustom ? customReward : selectedOption;
        });
        this.rewardValueText = ko.pureComputed(function () {
            return numeral(_this.rewardValue()).format(_this.priceFormat);
        });
        this.reputationBonusText = ko.pureComputed(function () {
            var rewardValue = _this.rewardValue();
            if (rewardValue <= 25)
                return 15;
            if (rewardValue <= 100)
                return 30;
            return 50;
        });
        this.decreaseCustomRewardValue = function () {
            var val = _this.rewardValue() - _this.rewardStep;
            if (val >= _this.minReward) {
                _this.rewardValue(val);
            }
        };
        this.increaseCustomRewardValue = function () {
            var val = _this.rewardValue() + _this.rewardStep;
            if (val <= _this.maxReward) {
                _this.rewardValue(val);
            }
        };
        this.rewardTitleOptions = merchantUtils_1.default.getRewardTitleOptions();
        this.rewardTitleMaxLength = 45;
        this.rewardTitle = ko.observable("Отличная книга!").extend({
            required: {
                onlyIf: function () {
                    return _this.stage() === "setRewardAmount" && _this.isCustomRewardValue();
                }
            },
            minLengthLength: { params: 3, message: "Слишком короткое название" },
            maxLength: { params: this.rewardTitleMaxLength, message: "Название не может быть длиннее 45-ти символов" }
        });
        this.rewardTitleHint = ko.pureComputed(function () {
            var title = _this.rewardTitle() || "";
            var characters = title.length;
            return characters + "/" + _this.rewardTitleMaxLength;
        });
        this.priceWithReward = ko.pureComputed(function () {
            var mode = _this.mode();
            var reward = parseInt(_this.rewardValue());
            return mode === "reward" ? reward : _this.price + reward;
        });
        this.priceWithRewardText = ko.pureComputed(function () {
            return "" + numeral(_this.priceWithReward()).format(_this.priceFormat);
        });
        this.bankcardOptions = ko.observableArray();
        this.selectedBankCard = ko.observable();
        this.promoCode = ko.observable().extend({
            required: {
                onlyIf: function () {
                    return _this.stage() === "promoCode";
                }
            }
        });
        this.showPopup = function (mode) {
            if (!app.ensureAuth("Только зарегистрированные пользователи могут купить книгу или подарить награду.", true)) {
                return;
            }
            _this.errorMessages([]);
            _this.stage("loading");
            app.f7.popup($("#buyWorkPopup")[0]);
            merchantUtils_1.default.initButton(_this, mode)
                .done(function (result) {
                if (result.status !== "Success") {
                    _this.stage("error");
                }
                else {
                    _this.errorMessages([]);
                    _this.mode(mode);
                    _this.selectRandomRewardTitle();
                    if (mode === "reward") {
                        _this.stage("setRewardAmount");
                    }
                    else if (mode === "gift") {
                        _this.stage("confirmBuyingGift");
                    }
                    else if (mode === "series") {
                        _this.stage("selectPaymentMethod");
                        _this.workId = -1;
                    }
                    else {
                        _this.stage("startBuyingWork");
                    }
                }
                if (_this.popupCancelled) {
                    _this.popupCancelled = false;
                }
                else {
                    app.f7.popup($("#buyWorkPopup")[0]);
                }
            });
        };
        this.popupCancelled = false;
        this.cancelPopup = function () {
            _this.popupCancelled = true;
            app.closePopup();
        };
        this.checkSavedBankCards = function (el, payMethod) {
            _this.selectedPaymentMethod(payMethod);
            merchantUtils_1.default.checkSavedBankCards(el, payMethod, _this, app);
        };
        this.deleteSavedCard = function () {
            merchantUtils_1.default.deleteSavedCard(_this);
        };
        this.goToStage = function (stage, mode) {
            $("#buyWorkPopup").scrollTop(0);
            merchantUtils_1.default.goToStage(stage, mode, _this);
        };
        this.payMethodEnabled = function () {
            var payMethods = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                payMethods[_i - 0] = arguments[_i];
            }
            return merchantUtils_1.default.payMethodEnabled(_this, payMethods);
        };
        this.selectPayMethod = function (el, payMethod) {
            _this.selectedPaymentMethod(payMethod);
            merchantUtils_1.default.createOder(el, payMethod, _this, null);
        };
        this.selectReward = function (value) {
            merchantUtils_1.default.selectReward(value, _this);
        };
        this.previousRandomTitles = [];
        this.submitPromoCode = function () {
            if (!app.ensureAuth("Только зарегистрированные пользователи могут использовать промокод.", true)) {
                return;
            }
            merchantUtils_1.default.submitPromoCode(_this, null);
        };
        $(element).appendTo(document.body);
        this.price = params.price;
        this.discount = params.discount;
        this.workId = params.workId;
        this.seriesId = params.seriesId;
        this.workStatus = params.workStatus;
        this.workTitle = JSON.parse("\"" + params.workTitle + "\"");
        this.freezed = params.freezed;
        this.rewardsEnabled = params.rewardsEnabled;
        this.coverUrl = params.coverUrl;
        this.visible = params.visible;
        this.allowDownloads = params.allowDownloads;
        this.fb2FileMaxSize = params.fb2FileMaxSize;
        this.userId = params.userId;
        this.balanceAmount = params.balanceAmount;
        this.giftsEnabled = params.giftsEnabled;
        this.isPurchased = params.isPurchased;
        this.downloadText = params.downloadText || "Доступно только чтение на сайте.";
        this.platform = params.platform;
        if (this.discount) {
            this.price = this.price - this.price * this.discount / 100;
        }
        this.customRewardValue.subscribe(function (newVal) {
            if (parseFloat(newVal) > _this.maxReward) {
                _this.customRewardValue(_this.maxReward);
            }
        });
        this.priceText = numeral(this.price).format(this.priceFormat);
        this.validation = ko.validatedObservable(this);
    }
    BuyButtonComponent.prototype.selectRandomRewardTitle = function () {
        var index = _.random(0, this.rewardTitleOptions.length - 1);
        merchantUtils_1.default.selectRewardTitle(index, this);
    };
    return BuyButtonComponent;
}(BaseComponent_1.default));
ko.components.register("mobile-buy-button", {});
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = BuyButtonComponent;
//# sourceMappingURL=mobileBuyButton.js.map